import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SINInputComponent } from '../../../../../ui/form-components/sin-input/sin-input/sin-input.component';

@Component({
  selector: 'app-member-table-sin-input',
  templateUrl: 'member-table-sin-input-component.html',
  styleUrls: ['member-table-sin-input.component.scss', '../member-table-input.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MemberTableSinInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class MemberTableSinInputComponent extends SINInputComponent {
  @Input() placeholder: string = '\u23FA\u23FA\u23FA \u23FA\u23FA\u23FA 000';

  public override writeValue(value: string | null): void {
    super.writeValue(value);
    this.showingSIN = !value;
    this.refreshMaskedDisplay();
  }
}
